import React, {Component} from 'react';
import {
    editCompanyAutoConnectNotFoundType,
    editCompanyAutoConnectType,
    getAutoConnectStatus,
    updateAutoConnectStatus
} from "../../../../../../../services/company/api";
import Translate, {t} from "../../../../../../../components/Translate";
import config from "../../../../../../../config";
import {silverInfoStyles} from "../../../../../../../utils/General";

class AutoConnectCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            autoConnectType: '',
            autoConnectNotFoundType: ''
        };
    }

    componentDidMount() {
        const {client} = this.props;
        getAutoConnectStatus(client.id).then(result => {
            this.setState({
                isChecked: result.enabled,
                autoConnectType: result.type,
                autoConnectNotFoundType: result.notFoundType,
            });
        }).catch(error => {
            console.error('Error fetching auto-connect status:', error);
        });
    }

    handleCheckboxChange = () => {
        const {client} = this.props;
        const {isChecked} = this.state;
        updateAutoConnectStatus(client.id, isChecked)
            .then(() => {
                this.setState(prevState => ({
                    isChecked: !prevState.isChecked,
                }));
            })
            .catch(error => {
                console.error('Error updating auto-connect status:', error);
            });
    };

    handleTypeSelectChange = (event) => {
        const {client} = this.props;
        this.setState(() => ({
            autoConnectType: event.target.value,
        }));
        editCompanyAutoConnectType(client.id, event.target.value);
    };

    handleNotFoundTypeSelectChange = (event) => {
        const {client} = this.props;
        this.setState(() => ({
            autoConnectNotFoundType: event.target.value,
        }));
        editCompanyAutoConnectNotFoundType(client.id, event.target.value);
    };

    render() {
        const {isChecked, autoConnectType, autoConnectNotFoundType} = this.state;
        const {user, features} = this.props;

        return (
            <div style={{display: "flex", margin: "15px", flexDirection: 'column'}}>
                <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                    <Translate text={'autoConnectLogic'}/>
                </h2>
                <div style={{display: 'flex'}}>
                    <label className="switch controller">
                        <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={this.handleCheckboxChange}
                        />
                        <span className="slider round"/>
                    </label>
                    <h2 style={silverInfoStyles.info}>
                        <Translate text="enable/disable"/>
                    </h2>
                </div>

                <br/>

                {isChecked && (
                    <div>
                        <h2 style={{...silverInfoStyles.info, marginLeft: '0px' }}>
                            <Translate text="operatorConnectionLogic"/>
                        </h2>
                        <select
                            value={autoConnectType}
                            onChange={() => this.handleTypeSelectChange(event)}
                            style={{
                                display: 'block',
                                width: '100%',
                                marginTop: '10px',
                                backgroundColor: 'white',
                                border: '1px solid rgb(221, 221, 221)',
                                fontSize: '16px',
                                padding: '10px',
                                borderRadius: '10px',
                                marginBottom: '10px',
                            }}
                        >
                            <option value={'DISTRIBUTE_EQUALLY'}>{t({text: "distributeEqually", user})}</option>
                            {features.includes(config.features.SKILLS) && (
                                <option value={'BY_SKILLS'}>{t({text: "bySkills", user})}</option>
                            )}
                        </select>
                    </div>
                )}

                <br/>

                {isChecked && (
                    <div>
                        <h2 style={{...silverInfoStyles.info, marginLeft: '0px' }}>
                            <Translate text="notFoundTypeExp"/>
                        </h2>
                        <select
                            value={autoConnectNotFoundType}
                            onChange={() => this.handleNotFoundTypeSelectChange(event)}
                            style={{
                                display: 'block',
                                width: '100%',
                                marginTop: '10px',
                                backgroundColor: 'white',
                                border: '1px solid rgb(221, 221, 221)',
                                fontSize: '16px',
                                padding: '10px',
                                borderRadius: '10px',
                                marginBottom: '10px',
                            }}
                        >
                            <option value={'MOVE_TO_UN_MANAGED_LIST'}>{t({text: "moveToUnmanagedList", user})}</option>
                            <option value={'MOVE_TO_QUEUE'}>{t({text: "moveToQueue", user})}</option>
                        </select>
                    </div>
                )}
            </div>
        );
    }
}

export default AutoConnectCheckbox;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/AutoConnectCheckbox.jsx